import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function FAUstairs() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>FAUstairs</BlockTitle>
          <BlockSubtitle><b>F</b>ormative <b>A</b>ssessment for <b>U</b>niversities: <b>St</b>rategic <b>A</b>pplication of <b>I</b>nnovative Methods to <b>R</b>aise <b>S</b>tudy Success Rates.</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText>The FAUstairs project is funded by the Foundation for Innovation in Higher Education (German: Stiftung Innovation in der Hochschullehre) and is carried out at the Friedrich-Alexander University Erlangen-Nürnberg (FAU). The primary objective of the project is to improve student success by developing innovative formative assessment strategies and modern digital learning environments. It seeks to integrate web-based technologies, learning analytics, and AI-supported educational tools into higher education, creating a flexible and accessible platform that enhances teaching, learning, and assessment.</BlockText>
        </BlockContent>
      </Block>





      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText><b>Project Start:</b> 01.10.2025</BlockText>
          <BlockText><b>Project End:</b> 30.09.2031</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent>
          <BlockSubtitle>Description</BlockSubtitle>
          <BlockText>The FAUstairs project (Formative Assessment for Universities: Strategic Application of Innovative Methods to Raise Study Success Rates) aims to improve academic success. The new teaching architecture developed and implemented as part of the project focuses on promoting learning and subject-specific skills, which are central components of FAU’s internal definition of academic success. Innovative and AI-supported formative and summative assessments are designed to support students in developing these skills. In addition, data-based modelling of FAU degree programmes is being used to develop a privacy-compliant monitoring system that allows the learning behaviour of students to be analysed, thus facilitating appropriate educational responses on the part of teachers or the learning environment. Educational and technical innovations are intertwined to create a holistic, competence-oriented teaching and learning environment.

          A key component of the FAUstairs teaching architecture is formative assessment, which enables targeted feedback to be given to students during their studies and courses. This feedback helps students to deepen their understanding of the subject matter and develop their skills systematically. Continuous feedback and reflection on their own learning process promotes the acquisition of skills, with the learning process itself – both in terms of self-regulation by learners and adaptive adjustment of teaching by lecturers – becoming increasingly central.

          FAUstairs aims to highlight the considerable need for innovation in the area of assessment at all levels, to exploit existing scope for action, to identify potential challenges and to develop solutions together with relevant stakeholders, including the Bavarian State Ministry of Science and the Arts. The success of the project is continuously monitored and evaluated using various parameters, in particular, study success rates.
          </BlockText>
        </BlockContent>
      </Block>

      {/* <Block colorTheme="dark">
        <BlockContent width="100%">
          <BlockSubtitle>Task Breakdown</BlockSubtitle>
          <BlockText>WIP</BlockText>
        </BlockContent>
      </Block> */}


      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://www.faustairs.fau.de/')}>Projectpage</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default FAUstairs;